const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9414"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21836",
    d: "M0 0h24v24H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26746",
    d: "M13.516 5.984c.554.2 1.092.345 1.584.584a5.238 5.238 0 0 1 .839 8.849 5.094 5.094 0 0 1-5.3.63.676.676 0 0 0-.5-.027 11.823 11.823 0 0 1-5.062.372 8.57 8.57 0 0 1-3.311-1.073 3.434 3.434 0 0 1-1.553-1.633 2.678 2.678 0 0 1-.2-.943Q-.011 8.255 0 3.767a2.8 2.8 0 0 1 1.325-2.284A7.338 7.338 0 0 1 4.45.219a11.555 11.555 0 0 1 6.232.459 4.769 4.769 0 0 1 2.385 1.707 2.534 2.534 0 0 1 .449 1.464v2.135zm2.984 5.263A3.747 3.747 0 1 0 12.775 15a3.752 3.752 0 0 0 3.727-3.75zm-9.749-9.74a9.415 9.415 0 0 0-2.987.433A4.158 4.158 0 0 0 1.8 3.069a.941.941 0 0 0-.01 1.354 3.1 3.1 0 0 0 1.269.877 9.928 9.928 0 0 0 6.955.174 3.635 3.635 0 0 0 1.706-1.056.909.909 0 0 0-.008-1.328 3.932 3.932 0 0 0-.959-.724 8.5 8.5 0 0 0-4-.857zM1.53 6.2a1.359 1.359 0 0 0 .533 1.483 7.283 7.283 0 0 0 1.4.767 9.783 9.783 0 0 0 4.073.53c.348-.018.612-.088.736-.447a.939.939 0 0 1 .172-.264c.286-.346.578-.688.855-1.019a11.229 11.229 0 0 1-7.77-1.05zm7.3 8.615c-.268-.419-.522-.788-.743-1.173a.313.313 0 0 0-.324-.189c-.693.01-1.388.04-2.078-.006a8.773 8.773 0 0 1-4.049-1.2.654.654 0 0 0-.1-.04 1.426 1.426 0 0 0 .676 1.6 7.125 7.125 0 0 0 1.258.649 9.782 9.782 0 0 0 4.178.513c.387-.022.775-.098 1.183-.153zm-1.305-4.332a10.423 10.423 0 0 1-5.991-1.29 1.458 1.458 0 0 0 .61 1.575c.114.082.228.166.349.237a7.664 7.664 0 0 0 3.471.963c.522.033 1.046.005 1.561.005z",
    transform: "translate(3.001 4.005)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: ".5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashTracking);
export default __webpack_public_path__ + "static/media/cash-tracking.212c126bfed8cab203d146f3e2a868d4.svg";
export { ForwardRef as ReactComponent };